// extracted by mini-css-extract-plugin
module.exports = {"root":"desktop-map_root__1QWoU","closeButton":"desktop-map_closeButton__XVLMj","mapContainer":"desktop-map_mapContainer__3hVj9"};